import React, { CSSProperties, FC } from 'react';
import './PendingIndicatorDot.scss';

interface PendingIndicatorDotProps {
  visible: boolean;
  color?: string;
  /** Overrides the default top-right position (e.g. to sit further outside
   * the corner than EventBlockContent's original placement). */
  style?: CSSProperties;
}

/**
 * Small pulsing dot marking a pending/suggested item — shared by
 * CustomTimeline/EventBlockContent's "tap to confirm" indicator (a
 * temporary/AI-suggested calendar event) and the AI chat's suggested-block
 * cards, so a pending item reads the same way in both places. Scale
 * 1→1.4 and opacity 0.7→1, 800ms each way, looping. Positioned top-right —
 * render inside a `position: relative` container.
 */
const PendingIndicatorDot: FC<PendingIndicatorDotProps> = ({
  visible,
  color = 'var(--color-primary)',
  style,
}) => {
  if (!visible) {
    return null;
  }

  return <div className="pending-indicator-dot" style={{ backgroundColor: color, ...style }} />;
};

export default PendingIndicatorDot;
